
let config = {
  env: process.env.NODE_ENV || 'development'
}

config.development = {
  api: 'http://localhost:8500/',
  auth: 'http://localhost:3000/',
  app: 'http://localhost:8080/',  
  home: 'http://localhost:4040/'  
}

config.staging = {
  api: 'https://staging-api.stapp.ca/',
  auth: 'https://staging-auth.stapp.ca/',
  app: 'https://staging-app.stapp.ca/',
  home: 'https://staging-home.stapp.ca/'
}

config.production = {
  api: 'https://api.sofiatutors.com/',
  auth: 'https://auth.sofiatutors.com/',
  app: 'https://app.sofiatutors.com/',
  home: 'https://sofiatutors.com/'
}

console.log('NODE ENV', config.env)

module.exports = config[config.env]


// WEBPACK FOOTER //
// ./src/configs/urls.js